import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "attrs"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 18:13:19
 * @LastEditTime: 2021-04-25 20:05:26
 * @LastEditors: wangshengqiang
 * @Description: 常见问题组件
 */
import React, { useMemo, useState } from 'react';
import classnames from 'classnames';
import { Iconfont } from '@/baseComponents';
import QuestionItem from './questionItem';
import './index.less';
const Question = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    attrs
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const {
    buttonText,
    maxLength,
    values = []
  } = attrs;
  const cls = classnames({
    'components-question-render': true,
    [className]: !!className
  });
  const [showMore, setShowMore] = useState(false);
  const data = useMemo(() => {
    if (showMore) {
      return values;
    }

    return maxLength ? values.slice(0, maxLength) : values;
  }, [showMore, values, maxLength]);

  const renderBody = () => {
    const items = data.map((item = {}, index) => {
      const {
        label = '',
        value = ''
      } = item;
      return /*#__PURE__*/React.createElement(QuestionItem, {
        showFolded: true,
        className: "question-item",
        key: index,
        label: label
      }, value);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "question-body"
    }, items);
  };

  const renderFooter = () => {
    if (!buttonText) {
      return null;
    }

    if (values.length <= maxLength) {
      return null;
    }

    const footerCls = classnames({
      'question-footer': true,
      reverse: !!showMore
    });

    const onClick = () => setShowMore(!showMore);

    return /*#__PURE__*/React.createElement("div", {
      className: footerCls,
      onClick: onClick
    }, /*#__PURE__*/React.createElement(Iconfont, {
      className: "icon",
      type: "biansechakangengduo"
    }), /*#__PURE__*/React.createElement("div", {
      className: "footer-title",
      "data-title": buttonText
    }));
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), renderBody(), renderFooter());
});
export default Question;